'use client'

import { useTranslation } from '@shared/config/i18n'
import Image from 'next/image'
import React, { ComponentProps } from 'react'

type Props = {
  onClickWrapper: () => void
} & Partial<ComponentProps<typeof Image>>

export const AiLearningBanner = ({ onClickWrapper, ...props }: Props) => {
  const t = useTranslation()

  return (
    <div role="banner" aria-label="ai-learning-banner" onClick={onClickWrapper} tabIndex={0}>
      <Image
        src="/images/banners/ai-learning.png"
        alt={t('homeBanners.alt.aiLearning')}
        width={400}
        height={115}
        className="w-full h-auto"
        {...props}
      />
    </div>
  )
}
